import globals from "../../../globals";
import { _sendWithAxios, _sendWithAxiosBlob } from "../../api";

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const cadastrarProdutoSeller = async (data, idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/cadastrar-produto-seller/${idEmpresa}`,
    "POST",
    data
  );
};

export const editarProdutoSeller = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/atualizar-produto-seller/`,
    "PUT",
    data
  );
};

export const inativarProdutoSeller = async (idProdutoSeller) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/inativar-produto-seller/${idProdutoSeller}`,
    "PUT"
  );
};

export const ativarProdutoSeller = async (idProdutoSeller) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/ativar-produto-seller/${idProdutoSeller}`,
    "PUT"
  );
};

export const detalheProdutoSeller = async (idProduto) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/detalhe-produto-seller/${idProduto}`,
    "GET"
  );
};
export const atualizarProdutos = async (idProduto) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/atualizar-todos-produtos`,
    "GET"
  );
};

export const statusReprocessamentoBase = async () => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/status-reprocessamento-base`,
    "GET"
  );
};

export const buscarDadosProdutoSeller = async (gtin, idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/buscar-dados-produto/${gtin}/${idEmpresa}`,
    "GET"
  );
};
export const buscarDadosProdutoSellerGtin = async (gtin, idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/atualizar-produto/${gtin}`,
    "GET"
  );
};

export const atualizarProdutoIntegracao = async (gtin, idEmpresa) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/atualizar-produto/${gtin}`,
    "GET"
  );
};

export const listarProdutosSeller = async (pagina, total = 10) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProduto/listar-produto/${pagina}/${total}`,
    "POST"
  );
};
// Ajustado para utilizar query params conforme solicitado
export const verificarEanSeller = async (idEmpresa, gtin, sku = null) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/valida/produto?idEmpresa=${idEmpresa}&gtin=${gtin}&sku=${sku}`,
    "POST"
  );
};

export const listarProdutosComSemFiltro = async (
  filtro,
  pagina,
  filtros = {}
) => {
  try {
    const requestBody = {
      filtro: filtro || null,
      cnpj: filtros.cnpj || null,
      status: filtros.status || null,
    };

    const response = await _sendWithAxios(
      `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/listar-produto-seller/${pagina}/10`,
      "POST",
      requestBody
    );
    return response;
  } catch (error) {
    console.error("Erro ao listar produtos:", error);
    throw error;
  }
};

export const gerarExelProdutosSeller = async (filtro = {}) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/gerar-exel-produtos-seller`,
    "POST",
    filtro
  );
};
export const gerarExelProdutosPost = async (data) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/gerar-exel-produtos-seller`,
    "POST",
    data
  );
};

export const uploadImagemProduto = async (file) => {
  const data = new FormData();
  data.append("file", file);
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Upload/upload/produtoSeller`,
    "POST",
    data
  );
};

export const gerarExelModeloBaseImportacao = async (idEmpresa) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/modelo-base-importacao/${idEmpresa}`,
    "GET"
  );
};
export const gerarExelModeloBaseImportacaoProduto = async (idEmpresa) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/modelo-base-importacao`,
    "GET"
  );
};

export const importarProdutos = async (file, emailUsuario) => {
  const data = new FormData();
  data.append("file", file);
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/importacao-produtos/${emailUsuario}`,
    "POST",
    data
  );
};

export const importarProdutosAdmin = async (file, emailUsuario, idEmpresa) => {
  const data = new FormData();
  data.append("file", file);
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/importacao-produtos/${emailUsuario}/${idEmpresa}`,
    "POST",
    data
  );
};

export const listarLogProdutosSeller = async (pagina) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/logs-produto/${pagina}/10`,
    "GET"
  );
};

export const gerarExportacaoResultadoLog = async (tipoResultadoLog, logId) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/exportacao-log-produto/${tipoResultadoLog}/${logId}`,
    "GET"
  );
};

export const excluirProdutoSeller = async (idProdutoSeller) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}CategoriaProdutoSeller/excluir-produto-seller/${idProdutoSeller}`,
    "DELETE"
  );
};
